import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from '@modules';
import { UiNgLetModule } from '@uipath/angular/directives/ui-ng-let';

import { UiFolderTreeBreadCrumbsComponent } from './ui-folder-tree-breadcrumbs.component';

@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        UiNgLetModule,
    ],
    declarations: [
        UiFolderTreeBreadCrumbsComponent,
    ],
    exports: [
        UiFolderTreeBreadCrumbsComponent,
    ],
})
export class UiFolderTreeBreadCrumbsModule { }
